// @ts-ignore
import calendar from './calendar.svg';

const CalendarIcon = () => {
    return <img className='calendar-icon' src={calendar} alt='Calendar icon' />;
};

export default CalendarIcon;
